<!--
 * @Author: qixiao
 * @Date: 2022-09-06 17:56:22
 * @LastEditTime: 2022-09-23 19:51:53
 * @LastEditors: liushumin
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <el-button icon="el-icon-plus" type="primary" style="width: 110px" @click="addClass">添加分类</el-button>
      <el-table :data="tableData" style="width: 100%; margin-bottom: 20px" :row-key="getKey" ref="table"
        :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }" :tree-props="{
          children: 'szEnterpriseInfoList',
          hasChildren: 'szEnterpriseInfoList.length>0',
        }">
        <el-table-column prop="name" label="分类名称" min-width="80">
        </el-table-column>
        <el-table-column prop="level" label="级别"> </el-table-column>
        <el-table-column prop="status" label="是否显示">
          <template slot-scope="{ row }">
            <div>
              <el-switch v-model="row.status == 10 ? true : false" @change="stsShow(row)" active-color="#018388"
                inactive-color="#BBBBBB">
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序"> </el-table-column>
        <el-table-column prop="" label="操作" min-width="100">
          <template slot-scope="{ row }">
            <div>
              <el-button type="primary" plain round size="small" @click="addSon(row)" v-show="row.level < 3">添加子分类
              </el-button>
              <el-button type="primary" plain round size="small" @click="amend(row)">编辑</el-button>
              <el-button type="primary" plain round size="small" @click="removeList(row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加分类" :visible.sync="dialogVisible_add" width="30%">
      <el-form :model="numberValidateForm" ref="numberValidateForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="分类名称" prop="typeName" :rules="[{ required: true, message: '分类名称不能为空' }]">
          <el-input type="age" v-model.trim="numberValidateForm.typeName" placeholder="请输入" autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="上级分类" prop="typeName">
          <el-select v-model="numberValidateForm.topClass" placeholder="请选择分类">
            <el-option v-for="(item, index) in tableData" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="typeName">
          <el-input v-model="numberValidateForm.slot"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="typeName">
          <el-radio v-model="numberValidateForm.isShow" label="10">显示</el-radio>
          <el-radio v-model="numberValidateForm.isShow" label="20">不显示</el-radio>
          <!-- <el-input v-model="numberValidateForm.isShow"></el-input> -->
        </el-form-item>
      </el-form>
      <div class="bottoms">
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_add = false">取 消</el-button>
          <el-button type="primary" @click="addList">确 认</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog title="添加子分类" :visible.sync="dialogVisible_add_son" width="30%">
      <el-form :model="numberValidateForm2" ref="numberValidateForm2" label-width="100px" class="demo-ruleForm">
        <el-form-item label="分类名称" prop="typeName" :rules="[{ required: true, message: '分类名称不能为空' }]">
          <el-input type="age" v-model.trim="numberValidateForm2.typeName" placeholder="请输入" autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="上级分类" prop="typeName">
          <!-- <el-select v-model="numberValidateForm2.topClass" placeholder="请选择分类"
                        :disabled="itemSon.level == 1 || itemSon.level == 3">
                        <el-option v-for="(item,index) in itemSon.szEnterpriseInfoList" :key="item.id"
                            :label="item.name" :value="item.id">
                        </el-option>
                    </el-select> -->
          <el-input type="age" v-model.trim="sonName" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="typeName">
          <el-input v-model="numberValidateForm2.slot"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="typeName">
          <el-radio v-model="numberValidateForm2.isShow" label="10">显示</el-radio>
          <el-radio v-model="numberValidateForm2.isShow" label="20">不显示</el-radio>
        </el-form-item>
      </el-form>
      <div class="bottoms">
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_add_son = false">取 消</el-button>
          <el-button type="primary" @click="sontrue">确 定</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog title="修改分类" :visible.sync="dialogVisible_xiugai_son" width="30%">
      <el-form :model="amendDetail" ref="amendDetail" label-width="100px" class="demo-ruleForm">
        <el-form-item label="分类名称" prop="" :rules="[{ required: true, message: '分类名称不能为空' }]">
          <el-input type="age" v-model.trim="amendDetail.name" placeholder="请输入" autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="上级分类" prop="">
          <el-select v-model="titleAmend" placeholder="请选择分类"
            :disabled="itemSon.level == 1 || itemSon.level == 3 || itemSon.level == 2">
            <el-option v-for="item in itemSon.szEnterpriseInfoList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="">
          <el-input v-model="amendDetail.sort"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="">
          <el-radio-group v-model="amendDetail.status">
            <el-radio :label="10">显示</el-radio>
            <el-radio :label="20">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="bottoms">
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_xiugai_son = false">取 消</el-button>
          <el-button type="primary" @click="xiugaitrue">确 定</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog title="修改提示" :visible.sync="dialogVisible_amend" width="19%">
      <div class="tac">
        <p>该分类已关联商品，重新修改后将同步修改。</p>
      </div>
      <div class="bottoms">
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_amend = false">取 消</el-button>
          <el-button type="primary" @click="amendAway">继续修改</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog title="删除分类" :visible.sync="dialogVisible_remove" width="19%">
      <div class="tac">是否确认删除该分类？</div>
      <div class="bottoms">
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_remove = false">取 消</el-button>
          <el-button type="primary" @click="removeData">确认</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog title="删除提示" :visible.sync="dialogVisible_removeTitle" width="19%">
      <div class="tac reds">分类已经关联商品，不可删除。</div>
      <div class="bottoms">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible_removeTitle = false">我知道了</el-button>
        </span>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      // 弹窗状态

      dialogVisible_add: false,
      dialogVisible_add_son: false,
      dialogVisible_amend: false,
      dialogVisible_remove: false,
      dialogVisible_removeTitle: false,
      dialogVisible_xiugai_son: false,

      // 表单数据

      numberValidateForm: {
        typeName: "", //分类名称
        topClass: "",
        slot: "",
        isShow: "10",
      },
      numberValidateForm2: {
        typeName: "", //分类名称
        topClass: "",
        slot: "",
        isShow: "10",
      },
      itemSon: [],
      sonName: "",
      amendDetail: {
        sort: "",
        name: "",
        id: "",
        level: "",
        status: 10,
      },
      //获取列表id

      getKey(val) {
        return val.id.toString();
      },
      remId: "",
      tableData: [],
      titleAmend: '',
      tableData1: [
        {
          id: 1,
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          id: 2,
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          id: 3,
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
          hasChildren: true,
        },
        {
          id: 4,
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
    };
  },
  mounted() { },
  created() {
    this.fn();
  },
  methods: {
    //获取分类列表

    fn() {
      try {
        this.$http.orders.ordersList().then((res) => {
          console.log(res);
          this.tableData = res.data;
          // this.classFather = res.data
        });
      } catch (error) { }
    },

    // 添加分类

    addClass() {
      this.dialogVisible_add = true;
    },

    addList() {
      let obj = {
        name: this.numberValidateForm.typeName,
        sort: this.numberValidateForm.slot,
        pid: this.numberValidateForm.topClass.toString(),
        status: this.numberValidateForm.isShow,
        level: 2,
      };
      if (obj.pid == "") {
        console.log(obj);
        obj.pid = 0;
        obj.level = 1;
      }
      console.log(obj);
      this.$http.orders.addFenlei(obj).then((res) => {
        console.log(res);
        this.$message({
          message: res.message,
          type: "success",
        });
      });
      this.dialogVisible_add = false;
      this.fn();
    },

    // 添加子分类

    addSon(val) {
      this.dialogVisible_add_son = true;
      this.itemSon = val;
      this.sonName = val.name;
      console.log(val);
    },

    sontrue() {
      let levels = this.itemSon.level + 1;
      let obj = {
        name: this.numberValidateForm2.typeName,
        sort: this.numberValidateForm2.slot,
        pid: this.numberValidateForm2.topClass.toString() || this.itemSon.id,
        status: this.numberValidateForm2.isShow,
        level: levels,
      };
      if (obj.pid == "") {
        console.log(obj);
        obj.pid = 0;
      }
      console.log(obj);
      this.$http.orders.addFenlei(obj).then((res) => {
        console.log(res);
        this.$message({
          message: res.message,
          type: "success",
        });
      });
      this.dialogVisible_add_son = false;
      this.fn();
      // (this.$refs.table as any).toggleRowExpansion(parentldArr, true)
    },

    //编辑

    amend(val) {
      console.log(val)
      this.dialogVisible_amend = true;
      this.amendDetail = {
        sort: val.sort,
        name: val.name,
        id: val.id,
        level: val.level,
        status: val.status,
        pid: val.pid
      };
      this.titleAmend = val.name
      this.itemSon = val;
      // console.log(typeof (this.amendDetail.sort));
      // console.log(typeof (this.amendDetail.name));
      // typeof(amendDetail.sort)
    },

    amendAway() {
      this.dialogVisible_amend = false;
      this.dialogVisible_xiugai_son = true;
    },

    xiugaitrue() {
      console.log(this.amendDetail);
      let obj = this.amendDetail;
      this.$http.orders.editList(obj).then((res) => {
        console.log(res);
        this.$message({
          message: res.message,
          type: "success",
        });
      });
      this.dialogVisible_xiugai_son = false;

      this.fn();
    },

    //删除

    removeList(val) {
      this.remId = val.id;
      console.log(val)
      this.$http.brandApi
        .getRemTitle({
          brandId: "",
          oneClassId: val.id,
          supplierId: "",
          threeClassId: "",
          twoClassId: "",
        })
        .then((res) => {
          console.log(res.data);
          if (res.data == 0) {
            this.dialogVisible_remove = true;

          } else {
            this.dialogVisible_removeTitle = true;
          }
          // this.dialogVisible_remove = false
          // this.$message({
          //     message: res.message,
          //     type: 'success'
          // });
        });

      // console.log(val.id)
      // this.remId = val.id
      // this.dialogVisible_remove = true
      // this.dialogVisible_removeTitle = true
    },

    removeData() {
      let obj = {
        id: this.remId,
      };
      this.$http.orders.remFenlei(obj).then((res) => {
        console.log(res);
        this.dialogVisible_remove = false;
        this.$message({
          message: res.message,
          type: "success",
        });
      });
      this.fn();
    },

    //滑块是否展示

    stsShow(val) {
      try {
        console.log(val);
        let blen = "";
        if (val.status == 10) {
          blen = 20;
        } else {
          blen = 10;
        }
        let obj = {
          id: val.id.toString(),
          status: blen,
        };
        this.$http.orders.ordersShow(obj).then((res) => {
          console.log(res);
        });
        this.fn();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-table {
  margin-top: 20px;
}

::v-deep .el-icon-plus {
  margin-left: -10px;
}

.bottoms {
  text-align: center;

  .el-button {
    width: 100px;
  }
}

.tac {
  text-align: center;
  font-size: 22px;
  color: #444444;
  margin-bottom: 33px;
}

.reds {
  color: #f31a1a;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  cursor: not-allowed;
}
</style>
